export default "__VITE_ASSET__Bi3Y6cRe__"